import React, {useState} from "react";
import { Menu, MenuItem, Grid, Button } from "@mui/material";
import { fetchDownloadFile } from "../../util/FileUtils";
import { getBuyerSpaceUsageGroupSummaryUrl } from "../../requests/reports/space-usage/buyer-space-usage-requests";
import { getSupplierSpaceUsageGroupSummaryReportUrl } from "../../requests/reports/space-usage/supplier-space-usage-requests";
import DownloadCsvIcon from "../icons/DownloadCsvIcon";
import {getErrorMessage} from "../../util/NetworkErrorUtil";
import {useSnackbar} from "../../context/snackbar-context";

export const groupByOptions = Object.freeze({
    BUYER: "BUYER",
    SUPPLIER: "SUPPLIER",
    LOCATION: "LOCATION",
    NONE: "NONE"
  });

// Buyer and supplier request param types are not exported, so derive them from the URL builders
type SpaceUsageQuery =
    Parameters<typeof getBuyerSpaceUsageGroupSummaryUrl>[0] &
    Parameters<typeof getSupplierSpaceUsageGroupSummaryReportUrl>[0];

interface DownloadSpaceUsageCSVButtonProps {
    query: SpaceUsageQuery;
    onError?: (error: Error) => void;
    isBuyer: boolean;
}

const DownloadSpaceUsageCSVButton = ({query, onError, isBuyer}: DownloadSpaceUsageCSVButtonProps) => {
    const { snackbarShowMessage } = useSnackbar();
    const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);

    const menuOpen = Boolean(menuAnchorEl);

    const handleClickMenuButton = (event: React.MouseEvent<HTMLElement>) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setMenuAnchorEl(null);
    };

    const handleExportByGroup = async (group: string) => {
        if(query && group) {
            const newQuery = Object.assign({}, query);
            newQuery.groupBy = group;
    
            if (isBuyer) {
                downloadFile(getBuyerSpaceUsageGroupSummaryUrl(newQuery))
            } else {
                downloadFile(getSupplierSpaceUsageGroupSummaryReportUrl(newQuery))
            }
        }

    }

    const handleError = (error: Error) => {
        if (onError) {
            onError(error);
        } else {
            snackbarShowMessage(getErrorMessage(error, undefined, 'fileDownload'), 'error');
        }
    };

    const downloadFile = async (reportUrl: string) => {
        fetchDownloadFile(reportUrl, undefined, handleError);
    };

    return (
        <Grid item>
            <Grid item>
                <Button variant={"contained"} startIcon={<DownloadCsvIcon/>} onClick={handleClickMenuButton}>Export Group Summaries</Button>
            </Grid>
            <Menu open={menuOpen} anchorEl={menuAnchorEl} onClose={handleCloseMenu}>
                {
                    isBuyer ?
                        <MenuItem onClick={() => handleExportByGroup(groupByOptions.SUPPLIER)}>
                            Group By Supplier
                        </MenuItem>
                    :
                        <MenuItem onClick={() => handleExportByGroup(groupByOptions.BUYER)}>
                            Group By Buyer
                        </MenuItem>
                }
                <MenuItem onClick={() => handleExportByGroup(groupByOptions.LOCATION)}>
                    Group By Location
                </MenuItem>
            </Menu>
        </Grid>
            )
}

export default DownloadSpaceUsageCSVButton;